"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tailwindcssProperties_json_1 = __importDefault(require("./tailwindcssProperties.json"));
var defaultOptions = {
    prefix: '',
    tailwindProperties: tailwindcssProperties_json_1.default,
};
exports.overrideTailwindClasses = function (classNamesString, optionsArg) {
    if (optionsArg === void 0) { optionsArg = defaultOptions; }
    var options = __assign(__assign({}, defaultOptions), optionsArg);
    var classNames = classNamesString.split(/\s+/);
    return classNames
        .reduce(function (result, className) {
        var classNameWithoutPrefix = className.startsWith(options.prefix) ? className.substring(options.prefix.length) : className;
        var propertiesForClass = options.tailwindProperties[classNameWithoutPrefix] || [];
        var nonClashingClasses = result.filter(function (r) { return !r.tailWindCssProperties.some(function (p) { return propertiesForClass.includes(p); }); });
        return __spreadArrays(nonClashingClasses, [{ class: className, tailWindCssProperties: propertiesForClass }]);
    }, [])
        .map(function (r) { return r.class; })
        .join(' ');
};
